import FilledButtonM from "@common/components/button/FilledButtonM"
import { theme } from "@common/theme/theme"
import { FontAwesome5 } from "@expo/vector-icons"
import React from "react"
import { View, StyleSheet } from "react-native"
import Animated, { FadeIn } from "react-native-reanimated"
import ChampionBubble from "../../../student/champions/ChampionBubble"

/**
 * PrerequisiteQuizGate - Locks the activity and displays Sam with a message to start the prerequisite quiz.
 *
 * Only ever rendered before the first attempt (`usePrerequisiteQuiz` hides it as
 * soon as `quiz_status` leaves `pending`): the quiz is one-shot, so there is no
 * "retry" state to word for. Failing does not keep the activity locked — the
 * student gets in and the tutor takes over.
 *
 * @param {Object} props
 * @param {Function} props.onStartQuiz - Callback when student clicks "Commencer le quiz"
 * @param {boolean} props.loading - Whether the quiz is being loaded
 */
const PrerequisiteQuizGate = ({ onStartQuiz, loading = false }) => {
    const message = "Avant de commencer l'activité, vérifions tes connaissances"

    return (
        <View style={styles.overlayContainer}>
            {/* Semi-transparent white backdrop to lock the activity */}
            <View style={styles.backdrop} />

            {/* Sam with message and button */}
            <Animated.View
                entering={FadeIn.duration(500)}
                style={styles.contentContainer}
            >
                <ChampionBubble
                    name="sam"
                    championPosition={"center"}
                    texts={[message]}
                    noAnimation={true}
                />

                <FilledButtonM
                    onPress={onStartQuiz}
                    label={loading ? "Chargement..." : "Commencer le quiz"}
                    icon="play"
                    color={theme.colors.primary}
                    style={styles.button}
                    disabled={loading}
                    loading={loading}
                />
            </Animated.View>
        </View>
    )
}

const styles = StyleSheet.create({
    overlayContainer: {
        ...StyleSheet.absoluteFillObject,
        top: 66, // Below the OneStepActivityHeader (height: 65)
        zIndex: 5,
        alignItems: "center",
        justifyContent: "center",
    },
    backdrop: {
        ...StyleSheet.absoluteFillObject,
        backgroundColor: 'rgba(255, 255, 255, 0.96)',
    },
    lockIconContainer: {
        position: "absolute",
        top: 40,
        alignSelf: "center",
    },
    lockIconCircle: {
        width: 48,
        height: 48,
        borderRadius: 24,
        backgroundColor: theme.colors.primary,
        alignItems: "center",
        justifyContent: "center",
        shadowColor: theme.colors.primary,
        shadowOffset: { width: 0, height: 2 },
        shadowOpacity: 0.3,
        shadowRadius: 4,
        elevation: 4,
    },
    contentContainer: {
        alignItems: "center",
        justifyContent: "center",
        paddingHorizontal: 20,
        paddingBottom: 60,
    },
    button: {
        marginTop: 20,
        minWidth: 220,
    },
})

export default PrerequisiteQuizGate

